import React from 'react';
import './PrivacyPage.css';
import Products2Hero from '../components/Products2Hero';

const PrivacyPage = () => {
  const privacyMarquee = [
    'Secure Data Handling',
    'Customer Privacy First',
    'Certified Security Standards',
    'Transparent Data Policy',
    'Compliant with Regulations',
    'Your Data, Your Control'
  ];

  const sections = [
    { id: 'sec-1', num: '01', title: 'Introduction' },
    { id: 'sec-2', num: '02', title: 'Data We Collect' },
    { id: 'sec-3', num: '03', title: 'Usage of Data' },
    { id: 'sec-4', num: '04', title: 'Security' },
    { id: 'sec-5', num: '05', title: 'Cookies' },
    { id: 'sec-6', num: '06', title: 'Controlling Data' },
  ];

  return (
    <div className="privacy-page">
      <Products2Hero 
        className="hero-tight"
        tagline="NEXAWAVE COMPLIANCE · DATA PROTECTION · SECURITY FIRST"
        title1="Privacy Policy"
        title2=""
        title3=""
        description=""
        button1Text="Read Policy"
        button1Link="#policy-content"
        button2Text="Terms of Service"
        button2Link="/terms"
        marqueeItems={privacyMarquee}
      />
      
      <div id="policy-content" className="privacy-content">
        {/* Sticky Sidebar Navigation */}
        <aside className="privacy-sidebar">
          <h4 className="sidebar-title">Quick Navigation</h4>
          <ul className="sidebar-nav">
            {sections.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`}>
                  <span className="sidebar-nav-num">{s.num}</span>
                  <span>{s.title}</span>
                </a>
              </li>
            ))}
          </ul>
        </aside>

        {/* Main Sections */}
        <div className="privacy-sections">
          {/* Introduction */}
          <section id="sec-1" className="privacy-section">
            <h2 className="section-title">Introduction</h2>
            <p className="section-text">
              This privacy policy sets out how NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED uses and protects any information that you give NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED when you visit their website and/or agree to purchase from them.
            </p>
            <p className="section-text">
              NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, then you can be assured that it will only be used in accordance with this privacy statement.
            </p>
            <p className="section-text">
              NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you adhere to these changes.
            </p>
          </section>

          {/* Data We Collect */}
          <section id="sec-2" className="privacy-section">
            <h2 className="section-title">We may collect the following information:</h2>
            <ul className="privacy-list">
              <li>Name</li>
              <li>Contact information including email address</li>
              <li>Demographic information such as postcode, preferences and interests</li>
              <li>Other information relevant to customer surveys and/or offers</li>
            </ul>
          </section>

          {/* Usage of Data */}
          <section id="sec-3" className="privacy-section">
            <h2 className="section-title">What we do with the information we gather</h2>
            <p className="section-text">
              We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:
            </p>
            <ul className="privacy-list full-width">
              <li>Internal record keeping.</li>
              <li>We may use the information to improve our products and services.</li>
              <li>We may periodically send promotional emails about new products, special offers or other information which we think you may find interesting.</li>
              <li>From time to time, we may also use your information to contact you for market research purposes. We may customize the website according to your interests.</li>
            </ul>
          </section>

          {/* Security */}
          <section id="sec-4" className="privacy-section">
            <h2 className="section-title">Security</h2>
            <p className="section-text">
              We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure we have put in suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.
            </p>
          </section>

          {/* Cookies */}
          <section id="sec-5" className="privacy-section">
            <h2 className="section-title">How we use cookies</h2>
            <p className="section-text">
              A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyze web traffic or lets you know when you visit a particular site.
            </p>
            <p className="section-text">
              We use traffic log cookies to identify which pages are being used. This helps us analyze data about webpage traffic and improve our website in order to tailor it to customer needs. 
            </p>
            <p className="section-text">
              Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.
            </p>
          </section>

          {/* Controlling Data */}
          <section id="sec-6" className="privacy-section">
            <h2 className="section-title">Controlling your personal information</h2>
            <p className="section-text">
              You may choose to restrict the collection or use of your personal information in the following ways:
            </p>
            <ul className="privacy-list full-width">
              <li>Whenever you are asked to fill in a form on the website, look for the box that you can click to indicate that you do not want the information to be used for marketing purposes.</li>
              <li>If you have previously agreed to us using your personal information, you may change your mind at any time by writing to or emailing us.</li>
            </ul>
            <p className="section-text">
              We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so.
            </p>
            <div className="disclaimer-box">
              <p>
                <strong>Disclaimer:</strong> The above content is created at NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED's sole discretion. Razorpay shall not be liable for any content provided here and shall not be responsible for any claims that may arise due to merchant’s non-adherence to it.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
